<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetTagsCloudSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $t } = useLocalization();

const defaults = ref<any>({
    sortType: 'Date',
    quantity: 5
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

const sortTypeOptions = computed<Option[]>(() =>
{
    return [
        { value: 'Date', text: $t('[[[Data dodania]]]') },
        { value: 'Alphabetic', text: $t('[[[Alfabetycznie]]]') },
        { value: 'Popularity', text: $t('[[[Popularność]]]') }
    ];
});

const quantity = computed<Option<number>[]>(() =>
{
    return new Array(10).fill(null).map((value, index) =>
    {
        return { value: index + 1, text: (index + 1).toString() };
    });
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function sortTypeChanged(): Promise<void>
{
    form.value.settings = {
        sortType: form.value.settings.sortType
    };
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Sortowanie]]]')" :invalid-feedback="form.$errors.first('settings.sortType')" :state="form.$errors.state('settings.sortType')">
        <IdeoFormSelect v-model="form.settings.sortType" :options="sortTypeOptions" value-field="value" text-field="text" @change="sortTypeChanged" />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Ilość wyświetlanych tagów]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')">
        <IdeoFormSelect v-model="form.settings.quantity" name="settings.quantity" :options="quantity" />
    </IdeoFormGroup>
</template>
